import { render, staticRenderFns } from "./GiftPromotionStatistics.vue?vue&type=template&id=37a6c921&scoped=true&"
import script from "./GiftPromotionStatistics.vue?vue&type=script&lang=js&"
export * from "./GiftPromotionStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=37a6c921&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6c921",
  null
  
)

export default component.exports